import type { SalesPersonResponse } from "@finn-no/mobility-dealer-types";
import { PersonImage } from "./Image.tsx";

const EmployeeCard = ({ salesPerson }: { salesPerson: SalesPersonResponse }) => {
  const { name, title, profileImageUrl, altText } = salesPerson;
  return (
    <article className="min-w-[224px] min-h-full flex flex-col items-center p-12 shadow-s rounded-8">
      <PersonImage image={profileImageUrl} altText={altText} />
      <div className="flex flex-col items-center gap-4 mt-12">
        <h3 className="card-title">{name}</h3>
        <p className="text-center text-sm text-s-text-subtle">{title}</p>
      </div>
    </article>
  );
};

export default EmployeeCard;
